import CForm from '@components/form/Container';
import CDatepicker from '@components/form/Datepicker';
import CFormElement from '@components/form/Element';
import CRadio from '@components/form/Radio';
import CCheckbox from '@components/form/Checkbox';
import CTextarea from '@components/form/Textarea';
import CTimepicker from '@components/form/Timepicker';
import CDayTimepicker from '@components/form/DayTimepicker';
import CUpload from '@components/form/Upload';
import CSelect from '@components/form/Select';
import CAddress from '@components/form/Address';

export default {
    components: {
        CForm,
        CFormElement,
        CDatepicker,
        CDayTimepicker,
        CRadio,
        CCheckbox,
        CTextarea,
        CTimepicker,
        CUpload,
        CSelect,
        CAddress
    }
}
